import { render } from "./RoomMessage.vue?vue&type=template&id=e40648c8&scoped=true"
import script from "./RoomMessage.vue?vue&type=script&lang=js"
export * from "./RoomMessage.vue?vue&type=script&lang=js"

import "./RoomMessage.vue?vue&type=style&index=0&id=e40648c8&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\swing_vue_chat\\chat_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e40648c8"]])

export default __exports__